import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  cmodal: {
    '& .mantine-Drawer-drawer': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'center',
      color: '#ffffff',
      background: 'linear-gradient(270deg, rgba(86, 135, 230, 0.8) 0%, rgba(100, 65, 237, 0.8) 120.05%)',
      backdropFilter: 'blur(34px)',
      padding: '29px 8%',
    },
  },
  footerActionContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '12px 20px',
    width: '100%',
    justifyContent: 'space-between',
  },
  contentContainer: {
    padding: '20px',
    paddingTop: '0px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '.mantine-12eugi5[data-weekend]': {
      color: '#000',
    },
    '.mantine-12eugi5[data-selected]': {
      color: '#fff',
    },
  },
  dateInputWrapper: {
    width: '100%',
    fontWeight: 500,
    fontSize: '20px',
    display: 'flex',
    justifyContent: 'center',
    '& .mantine-DatePicker-input': {
      height: '45px',
      background: '#FFFFFF1A',
      border: 'none',
      outlineColor: '#019DE6',
      outlineWidth: '1px',
      borderRadius: '8px',
      width: '100%',
      padding: '12px 24px',
      color: '#ffffff',
      fontSize: '16px',
      fontWeight: 500,
    },
  },
  dateInput: {
    height: '45px',
    background: '#FFFFFF1A',
    border: '0.8px solid #959EB2',
    outlineColor: '#019DE6',
    outlineWidth: '1px',
    borderRadius: '8px',
    width: '100%',
    padding: '12px 24px',
    color: '#ffffff',
  },
  inputDescription: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    color: '#8C8C8C',
    marginTop: '8px',
  },
  inputLeft: {
    fontWeight: 500,
    fontSize: '16px',
  },
  changeNumberLink: {
    marginTop: 'auto',
    marginBottom: '20px',
    color: '#1DBBF0',
  },
  subtext: {
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '16px',
  },
  newbutton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '8px 16px',
    gap: '10px',
    color: '#000000',
    borderRadius: '16px',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    border: 'none',
    background: '#ffffff',
  },
  transbutton: {
    color: '#ffffff',
    background: '#ffffff1A',
  },
  newbuttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
  },
  dateInfoText: {
    marginTop: 'auto',
    textAlign: 'center',
    lineHeight: '32px',
    '& b': {
      color: '#597EF7',
    },
    [`@media (min-width: ${theme.breakpoints.xs})`]: {
      marginBottom: '20px',
    },
  },
  footer: {
    padding: 0,
    flexDirection: 'column',
  },
}));

export default useStyles;
